import { render, staticRenderFns } from "./InspeccionGestiona.vue?vue&type=template&id=13d9c810"
import script from "./InspeccionGestiona.vue?vue&type=script&lang=js"
export * from "./InspeccionGestiona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports